// src/env/index.ts
import { solanaBootstrapEnv } from "./../runtime/bootstrap.js";
import { loadSolanaEnv } from "./solana.js";

let ENV: ReturnType<typeof buildEnv> | null = null;

function buildEnv() {
  return {
    solana: loadSolanaEnv(),
  };
}


export function loadEnvConfig() {
  if (!ENV) {
    solanaBootstrapEnv();        // load dotenv first
    ENV = buildEnv();      // then read process.env
  }
  return ENV;
}
// src/env/index.ts
export * from "./solana.js";
export * from "./loadEnv.js";
